import { Progress } from 'antd';

import { COLORS } from '@/shared/constants/colors';
import { useMockProgress } from '@/shared/hooks/useMockProgress';

export const CircleProgress = () => {
  const { mockProgress } = useMockProgress();

  return (
    <Progress
      type="circle"
      trailColor={COLORS.systemDark50A}
      strokeColor={COLORS.systemSky200}
      percent={mockProgress}
      strokeWidth={18}
      size={40}
      format={() => ''}
    />
  );
};
